import { useState } from 'react'
import { Col, Container, Form, Row, Table } from 'react-bootstrap'
import {
  ArrowsCollapse,
  ArrowsExpand,
  Check2Square,
  Search,
  Tools,
} from 'react-bootstrap-icons'
import Lottie from 'react-lottie'
import squaresMoving from '../../assets/lottie/squares-moving.json'
import { CustomButton } from '../../components/CustomButton'
import Navbar from '../../components/navbar/navbar'
import { useOrdenation } from '../../hooks/useOrdenation'
import EstruturasService from '../../services/database/EstruturasService'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { ModalAjustar } from './ModalAjustar'

export function AjusteComposicao() {
  const [searchComposicao, setSearchComposicao] = useState('')
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [products, setProducts] = useState([])
  const [selectedComposition, setSelectedComposition] = useState({})
  const [kitsSku, setKitsSku] = useState([])
  const [isModalAjustarOpen, setIsModalAjustarOpen] = useState(false)
  const [skuToRemove, setSkuToRemove] = useState('')

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(products, 'descricao', 'asc')

  async function handleSearch() {
    setSelectedComposition({})
    setKitsSku([])

    try {
      setIsSearchLoading(true)

      const data =
        await EstruturasService.getAllProductsBySKUComposition(searchComposicao)

      setSkuToRemove(searchComposicao)
      setProducts(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao pesquisar a composição')
    } finally {
      setIsSearchLoading(false)
    }
  }

  function selectAll(data) {
    for (const product of data) {
      setKitsSku((prevState) => {
        if (!prevState.includes(product.sku)) {
          return [...prevState, product.sku]
        }

        return prevState
      })
    }
  }

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        <h1>Ajuste de Composição</h1>
        <p
          style={{
            textAlign: 'center',
          }}
        >
          Mude a composição de KITs trocando um produto X por um produto Y de
          forma massiva.
        </p>

        <Row className="mb-3">
          <Col xs={2}>
            <Form.Label>SKU da Composição</Form.Label>

            <Form.Control
              value={searchComposicao}
              onChange={(e) => setSearchComposicao(e.target.value)}
              placeholder="Pesquise..."
              onKeyDown={(e) => {
                if (e.key === 'Enter' && searchComposicao) {
                  handleSearch()
                }
              }}
            />
          </Col>

          <Col xs={2}>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                height: '100%',
              }}
            >
              <CustomButton
                noMargin
                title="Pesquisar"
                onClick={handleSearch}
                isLoading={isSearchLoading}
                isLoadingText="Pesquisando..."
                isDisabled={!searchComposicao}
              >
                <Search />
              </CustomButton>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={2}>
            <Form.Label>Produtos p/ pág.</Form.Label>

            <Form.Select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(e.target.value)}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Form.Select>
          </Col>

          <Col xs={2}>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                height: '100%',
              }}
            >
              <CustomButton
                noMargin
                title="Ajustar"
                onClick={() => setIsModalAjustarOpen(true)}
                isDisabled={kitsSku.length === 0}
              >
                <Tools />
              </CustomButton>
            </div>
          </Col>
        </Row>

        {isSearchLoading ? (
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: squaresMoving,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
            height={400}
            width={400}
          />
        ) : filteredItems.length > 0 ? (
          <>
            <Table
              striped
              hover
              bordered
            >
              <thead>
                <tr>
                  <th colSpan={3}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <CustomButton
                        noMargin
                        title="Selecionar/Desmarcar Todos"
                        onClick={() => {
                          if (kitsSku.length > 0) {
                            setKitsSku([])
                          } else {
                            selectAll(products)
                          }
                        }}
                      >
                        <Check2Square />
                      </CustomButton>

                      <p>
                        Mostrando {filteredItems.length} de{' '}
                        {products.length}{' '}
                      </p>

                      <p>
                        {kitsSku.length}{' '}
                        {kitsSku.length > 1 ? 'selecionados' : 'selecionado'}
                      </p>
                    </div>
                  </th>
                </tr>

                <tr>
                  <th>
                    <Form.Check
                      checked={
                        filteredItems.length > 0 &&
                        filteredItems.every((product) =>
                          kitsSku.includes(product.sku),
                        )
                      }
                      disabled={filteredItems.length === 0}
                      onChange={(e) => {
                        if (e.target.checked) {
                          selectAll(filteredItems)
                        } else {
                          for (const product of filteredItems) {
                            setKitsSku((prevState) =>
                              prevState.filter(
                                (productSku) => productSku !== product.sku,
                              ),
                            )
                          }
                        }
                      }}
                    />
                  </th>

                  <Th
                    value="sku"
                    label="SKU"
                  />
                  <Th
                    value="descricao"
                    label="Descrição"
                  />
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((product, index) => (
                  <>
                    <tr key={product.sku}>
                      <td>
                        <Form.Check
                          checked={kitsSku.includes(product.sku)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setKitsSku((prevState) => [
                                ...prevState,
                                product.sku,
                              ])
                            } else {
                              setKitsSku((prevState) =>
                                prevState.filter(
                                  (productSku) => productSku !== product.sku,
                                ),
                              )
                            }
                          }}
                        />
                      </td>
                      <td>{product.sku}</td>
                      <td>
                        <div
                          style={{
                            display: 'flex',
                            alignContent: 'center',
                            gap: 5,
                          }}
                        >
                          {product.descricao}

                          <button
                            style={{
                              all: 'unset',
                            }}
                            onClick={() =>
                              setSelectedComposition((prevState) =>
                                prevState[index]
                                  ? {}
                                  : { [index]: product.composition },
                              )
                            }
                          >
                            {selectedComposition[index] ? (
                              <ArrowsCollapse
                                color="#2563eb"
                                size={20}
                                style={{
                                  cursor: 'pointer',
                                }}
                              />
                            ) : (
                              <ArrowsExpand
                                color="#2563eb"
                                size={20}
                                style={{
                                  cursor: 'pointer',
                                }}
                              />
                            )}
                          </button>
                        </div>
                      </td>
                    </tr>

                    {selectedComposition[index] && (
                      <tr>
                        <td colSpan={3}>
                          <Table>
                            <thead>
                              <tr>
                                <th>Imagem</th>
                                <th>SKU</th>
                                <th>Descrição</th>
                                <th>Quantidade</th>
                              </tr>
                            </thead>

                            <tbody>
                              {selectedComposition[index]?.map((comp) => (
                                <tr>
                                  <td>
                                    {!comp.img_capa ? (
                                      <img
                                        src={`${process.env.REACT_APP_IMAGE_URL_API}/no-image.jpg`}
                                        style={{
                                          width: 50,
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={`${process.env.REACT_APP_IMAGE_URL_API}/${comp.img_capa}`}
                                        style={{
                                          width: 50,
                                        }}
                                      />
                                    )}
                                  </td>
                                  <td>{comp.sku}</td>
                                  <td>{comp.descricao}</td>
                                  <td>{comp.quantidade}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        ) : (
          <p
            style={{
              textAlign: 'center',
            }}
          >
            Nenhum produto encontrado
          </p>
        )}
      </Container>

      {isModalAjustarOpen && (
        <ModalAjustar
          isOpen={isModalAjustarOpen}
          onClose={() => setIsModalAjustarOpen(false)}
          kitsSku={kitsSku}
          skuToRemove={skuToRemove}
        />
      )}
    </>
  )
}
